<template>
  <div class="service-qualityreport">
    <div class="module-item-style filter-container">
      <el-date-picker
        v-model="selectTime"
        type="daterange"
        @change="timeSelect"
        :picker-options="pickerOptions"
        range-separator="~"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        format="yyyy-MM-dd"
        value-format="timestamp"
      ></el-date-picker>
      <div class="date-detail-filter">
        <div
          class="date-item"
          :class="chooseDate == index ? 'date-actived' : ''"
          v-for="(item, index) in dateOptions"
          :key="index"
          @click="chooseTime(index,item.value)"
        >
          {{item
          .name}}
        </div>
      </div>
      <div class="report-filter-top-button">
        <div class="wl-btn" @click="exportData">导出差评数据</div>
      </div>
    </div>

    <div class="module-item-style" v-loading="loadingData">
      <el-table 
      :data="tableData" 
      stripe
      border 
      style="width: 100%">
        <el-table-column prop="csName" fixed align=“center” label="客服昵称" ></el-table-column>
        <el-table-column prop="evaluate_grade_1" align=“center” label="非常不满意"></el-table-column>
        <el-table-column prop="evaluate_grade_2" align=“center” label="比较不满意"></el-table-column>
        <el-table-column prop="evaluate_grade_3" align=“center” label="一般"></el-table-column>
        <el-table-column prop="evaluate_grade_4" align=“center” label="比较满意"></el-table-column>
        <el-table-column prop="evaluate_grade_5" align=“center” label="非常满意"></el-table-column>
      </el-table>
      <pagenations
        :total="total"
        :size="pageSize"
        @pageHandler="pageOperate">
    </pagenations>
    </div>
  </div>
</template>

<script>
import pagenations from '@/components/pagenations/pagenations'
export default {
  name: "service-qualityreport",
  components: {
    pagenations
  },
  data() {
    return {
      selectTime: "",
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6; //如果没有后面的-8.64e6就是不可以选择今天的
        }
      },
      chooseDate: "0",
      setDate: "lastday",
      dateOptions: [
        { name: "昨天", value: "lastday" },
        { name: "上周", value: "lastweek" },
        { name: "上月", value: "lastmonth" }
      ],
      startTime: "",
      endTime: "",
      tableData: [],
      total: 0,
      currentPage: 1,
      loadingData: false,
      pageSize: 10
    };
  },
  created() {
    this.getQualityData();
  },
  mounted() {},
  methods: {
    exportData() {
      let exportParams = {};
      if (this.setDate == "") {
        exportParams = {
          startTime: this.startTime,
          endTime: this.endTime
        };
      } else {
        exportParams = {
          date: this.setDate
        };
      }
      var params = Object.keys(exportParams)
        .map(function(key) {
          // body...
          return (
            encodeURIComponent(key) +
            "=" +
            encodeURIComponent(exportParams[key])
          );
        })
        .join("&");
      let exportUrl =
        process.env.VUE_APP_API_URL +
        "/wlapi/evaluate/poorEvaluateOutExcel?" +
        params;
      window.open(exportUrl);
    },
    /**
     *  分页操作
     * @param val
     */
    pageOperate(val) {
      if (val.type == "currentChange") {
        this.currentPage = val.val;
      } else if (val.type == "sizeChange") {
        this.pageSize = val.val;
      }
      this.getQualityData();
    },
    chooseTime(index, val) {
      if (this.chooseDate != index) {
        this.chooseDate = index;
        this.setDate = val;
        this.selectTime = "";
        this.startTime = "";
        this.endTime = "";
        this.$nextTick(() => {
          this.getQualityData();
        });
      }
    },
    /**
     * 时间选择
     */
    timeSelect() {
      if (this.selectTime) {
        this.startTime = this.selectTime[0] / 1000;
        let endTime = this.selectTime[1] / 1000;
        this.endTime = endTime + 24 * 60 * 60 - 1;
        this.chooseDate = "-1";
        this.setDate = "";
      } else {
        this.startTime = "";
        this.endTime = "";
        this.chooseDate = "0";
        this.setDate = "lastday";
      }
      this.$nextTick(() => {
        this.getQualityData();
      });
    },
    getQualityData() {
      this.loadingData = true;
      this.$http
        .getServiceReportAPI({
          pageSize: this.pageSize,
          pageNum: this.currentPage,
          startTime: this.startTime,
          endTime: this.endTime,
          date: this.setDate
        })
        .then(res => {
          if (res.status == 1) {
            let data = res.data;
            this.tableData = data.list;
            this.total = data.total;
          }
          this.loadingData = false;
        })
        .catch(err => {
          this.loadingData = false;
        });
    }
  }
};
</script>

<style lang="scss">
.service-qualityreport {
  .filter-container {
    display: flex;
    align-items: center;
    .date-detail-filter {
      display: flex;
      align-items: center;
      .date-item {
        margin-left: 40px;
        font-size: 12px;
        color: #333;
        cursor: pointer;
        padding-bottom: 4px;
        border-bottom: 2px solid #fff;
        &.date-actived {
          color: $mainColor;
          border-bottom: 2px solid $mainColor;
        }
      }
    }
    .report-filter-top-button {
      margin-left: auto;
    }
  }

  .el-table td, .el-table th{
    text-align: center;
  }
}
</style>
